<template>
  <div>
    <PrimaryBox>
      <template slot="title">路网动态</template>
      <template slot="more">
        <span class="more" @click="showMore">更多></span>
      </template>
      <div v-if="WarningList.length">
        <vueSeamlessScroll :data="WarningList" class="content" :class-option="defaultOption">
          <div>
            <div class="warningBox" v-for="(item,index) in WarningList" :key="index" @click="showModal(item)">
              <img class="img" :src="IconRedList[IconRedList.length-1]"/>
              <p class="title">{{ item.eventTitle }}</p>
              <p class="type">类型:{{ item.eventTypeName }}</p>
              <p class="times">{{ $moment(item.eventReceptionTime).format('MM-DD') }}</p>
            </div>
          </div>
        </vueSeamlessScroll>
      </div>
      <div v-else>
        <div style="width: 100%;height: 25vh;text-align: center;line-height: 25vh;">
          <span style="color: #2b85e4;font-size: .9rem;font-weight: bold;">暂无数据</span>
        </div>
      </div>
    </PrimaryBox>
    <Modal v-model="modalIsShow" footer-hide transfer>
      <el-descriptions :title="modalData.title" direction="horizontal" :column="1">
        <el-descriptions-item label="预警标题">{{ modalData.eventTitle }}</el-descriptions-item>
        <el-descriptions-item label="所属区县">{{ modalData.deptName }}</el-descriptions-item>
        <el-descriptions-item label="描述">{{ modalData.eventDescription }}</el-descriptions-item>
        <el-descriptions-item label="上传时间">{{
            $moment(modalData.effectiveDate).format('yyyy-MM-DD HH:mm:ss')
          }}
        </el-descriptions-item>
        <el-descriptions-item label="类型">{{ modalData.eventTypeName }}</el-descriptions-item>
        <el-descriptions-item label="事件图片">
          <el-image :src="modalData.eventImgPath"></el-image>
        </el-descriptions-item>
      </el-descriptions>
    </Modal>
    <Modal v-model="moreIsShow" footer-hide :width="70" title="监控列表" transfer
           @on-visible-change="visibleChange">
      <div class="top">
        <div style="width: 10%;height:3vh;float: left">
          <Select v-model="currentCounty" @on-change="getMonitorPointAndNumber">
            <Option v-for="(item,index) in countyList" :key="index" :label="item.name" :value="item.indexCode"></Option>
          </Select>
        </div>
        <div style="width: 30%;float: right">
          <Checkbox v-model="isLine" @on-change="getMonitorPointAndNumber">只显示在线</Checkbox>
          <RadioGroup v-model="gridType" @on-change="changeScreen">
            <Radio :label="4"><span>四分屏</span></Radio>
            <Radio :label="9"><span>九分屏</span></Radio>
          </RadioGroup>
        </div>
      </div>
      <div class="contents" style="height: 65vh">
        <div class="leftBox">
          <div class="box">
            <div class="isLineBox">
              <p class="value">{{ ((parseInt(iconList[1].num) / parseInt(iconList[0].num)) * 100).toFixed(1) }}<span
                style="font-size: .3rem;">%</span></p>
              <span class="title">在线率</span>
            </div>
            <div class="detail">
              <div v-for="(item,index) in iconList" :key="index">
                <img class="img" :src="item.icon" alt="">
                <p class="num">{{ item.num }}</p>
                <p class="title">{{ item.title }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="rightBox">
          <div id="playVideo">
            <div v-if="gridType === 4">
              <jessibuca4 ref="jessibuca4" :videolist="videolist" :streamStatusList="streamStatusList"
                          :cameraTypeList="cameraTypeList" :cameraDetailList="cameraDetailList"
                          :isFullScreen="isFullScreen" :videonamelist="videonamelist"></jessibuca4>
            </div>
            <div v-if="gridType === 9">
              <jessibuca9 ref="jessibuca9" :videolist="videolist" :streamStatusList="streamStatusList"
                          :cameraTypeList="cameraTypeList" :cameraDetailList="cameraDetailList"
                          :isFullScreen="isFullScreen" :videonamelist="videonamelist"></jessibuca9>
            </div>
          </div>
          <div style="margin-top: 10px;height: 3vh">
            <div style="width: 50%;margin:  0 auto">
              <Page
                :total="dataTotal"
                show-total
                :page-size="pageSize"
                :current-page="currentPage"
                @on-change="pageChange"
              />
            </div>
          </div>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import PrimaryBox from "@/views/Screen/components/PrimaryBox/PrimaryBox";
import vueSeamlessScroll from "vue-seamless-scroll";
import IconRed from "@/views/Screen/images/iconRed.png";
import IconYellow from "@/views/Screen/images/iconYellow.png";
import IconBlue from "@/views/Screen/images/iconBlue.png";
import IconOrange from "@/views/Screen/images/iconOrange.png";
import Jessibuca9 from "@/views/stereoscopicInspection/components/flvh265-9.vue";
import Jessibuca4 from "@/views/stereoscopicInspection/components/flvh265-4.vue";
import Shexiangtou from "@/views/Screen/images/icon_shexiangtou.png";
import Shexiangtouzaixian from "@/views/Screen/images/icon_shexiangtouzaixian.png";
import Shexiangtoulixian from "@/views/Screen/images/icon_shexiangtoulixian.png";
// import dynamicYujing from "@/views/Screen/images/dynamic_yujing.png";
// import DynamicJianKong from "@/views/Screen/images/dynamic_jiankong.png";
// import dynamicLukuang from "@/views/Screen/images/dynamic_lukuan.png";
import DynamicJianKong from '../../images/dynamic_jiankong.png';
import dynamicYujing from '../../images/dynamic_yujing.png';
import dynamicLukuang from '../../images/dynamic_lukuan.png';

export default {
  name: "EarlyWarning",
  components: {
    Jessibuca4,
    Jessibuca9,
    PrimaryBox,
    vueSeamlessScroll
  },
  computed: {
    defaultOption() {
      return {
        step: 0.2, // 数值越大速度滚动越快
        limitMoveNum: 5, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000 // 单步运动停止的时间(默认值1000ms)
      }
    }
  },
  data() {
    return {
      modalIsShow: false,
      IconRedList: [dynamicYujing, dynamicYujing, dynamicLukuang, DynamicJianKong],
      WarningList: [],
      modalData: {},
      videolist: [],
      monitorPointList: [],
      videonamelist: [],
      cameraTypeList: [],
      cameraDetailList: [],
      isFullScreen: false,
      streamStatusList: [],
      moreIsShow: false,
      countyList: [],
      currentCounty: null,
      isLine: true,
      gridType: 4,
      currentPage: 1,
      pageSize: 4,
      dataTotal: 0,
      iconList: [{
        icon: Shexiangtou,
        title: '摄像头总数',
        num: 0
      }, {
        icon: Shexiangtouzaixian,
        title: '在线摄像头',
        num: 0
      }, {
        icon: Shexiangtoulixian,
        title: '离线摄像头',
        num: 0
      }]
    }
  },
  mounted() {
    this.getWarningList();
  },
  methods: {
    getImg(item) {
      let types = item.eventType === null ? '0' : parseInt(item.eventType) > 3 ? '0' : item.eventType;
      return this.IconRedList[parseInt(types)];
    },
    // 弹出视频弹窗
    showMore() {
      this.moreIsShow = true
      this.$nextTick(() => {
        this.getSubordinateCounty()
        this.getMonitorPointAndNumber()
      })
    },
    getMonitorPointAndNumber() {
      this.destoryVideo();
      this.getMonitorPointNumber()
      this.getMonitorPoint()
    },
    changeScreen() {
      this.pageSize = this.gridType
      this.destoryReverseVideo();
      this.getMonitorPoint()
    },
    // 获取相关数量
    getMonitorPointNumber() {
      this.$http.get(`/api/point/getMonitorPointNumber?indexCode=${this.currentCounty}`).then(res => {
        if (res.status === 200) {
          this.iconList[0].num = res.data[0].total
          this.iconList[1].num = res.data[0].normal
          this.iconList[2].num = res.data[0].abnormal
        }
      })
    },
    visibleChange(val) {
      if (!val) {
        this.destoryVideo();
      }
    },
    // 获取监控
    getMonitorPoint() {
      let params = {
        unitindexcode: this.currentCounty,
        streamingstatus: this.isLine ? 'normal' : ''
        // pageNum: this.currentPage,
        // pageSize: this.pageSize
      }
      this.$http.post(`/api/point/monitorPoint?page=${this.currentPage}&&size=${this.pageSize}`, params).then(res => {
        // console.log(res)
        if (res.data.status === '200') {
          let videos = this.formatData(res.data.data.list);
          console.log(videos)
          this.videolist = videos[0];
          this.streamStatusList = videos[1];
          this.videonamelist = videos[2];
          this.cameraTypeList = videos[3];
          this.cameraDetailList = videos[4];
          this.dataTotal = res.data.data.total
          this.$nextTick(() => {
            this.switchStart()
          })
        }
      })
    },
    // 获取视频监控数据
    getVideoSurveillanceData() {
      this.$http.post("/api/point/monitorPoint?page=1&size=2", {
        streamingstatus: "normal"
      }).then(res => {
        if (res.status === 200) {
          this.monitorPointList = res.data.data.list;
          this.$refs.monitorWin1.playVideo()
          this.$refs.monitorWin2.playVideo()
        }
      });
    },
    // 获取下级区县
    getSubordinateCounty() {
      this.$http.get("/api/getLowerLevelDepts?flag=3").then(res => {
        if (res.status === 200) {
          this.countyList = res.data;
          this.currentCounty = res.data[0].indexCode;
          this.$nextTick(() => {
            this.getMonitorPoint()
            this.getMonitorPointNumber();
          })
        }
      });
    },
    formatData(data) {
      let videolist = [];
      let streamStatusList = [];
      let videonamelist = [];
      let cameraTypeList = []
      let cameraDetailList = []
      let closeOfflinePlay = this.closeOfflinePlay;
      for (const item of data) {
        item['stream_url'] = `${this.$videoUrl}/rtp/${item['deviceId']}_${item['deviceId']}.live.flv`
        if (item['streamingstatus'] == 'normal') {
          streamStatusList.push('online');
          videolist.push(item['stream_url']);
          videonamelist.push(item['name']);
          cameraTypeList.push(item['cameratype'])
          cameraDetailList.push(item)
        } else {
          if (!closeOfflinePlay) {
            videolist.push(item['stream_url']);
            streamStatusList.push('offline');
            videonamelist.push(item['name']);
          }
        }
      }
      return [videolist, streamStatusList, videonamelist, cameraTypeList, cameraDetailList]
    },
    switchStart() {
      if (this.gridType == '9') {
        this.$refs.jessibuca9.switchStart();
      } else if (this.gridType == '4') {
        this.$refs.jessibuca4.switchStart();
      }
    },
    destoryVideo() {
      if (this.gridType == '9') {
        this.$nextTick(() => {
          this.$refs.jessibuca9.batchDestoryVideo();
        })
      } else if (this.gridType == '4') {
        this.$nextTick(() => {
          this.$refs.jessibuca4.batchDestoryVideo();
        })
      }
    },
    destoryReverseVideo() {
      if (this.gridType === 9) {
        this.$nextTick(() => {
          if (this.$refs.jessibuca4) {
            this.$refs.jessibuca4.batchDestoryVideo();
          }
        })
      } else if (this.gridType === 4) {
        this.$nextTick(() => {
          if (this.$refs.jessibuca9) {
            this.$refs.jessibuca9.batchDestoryVideo();
          }
        })
      }
    },
    screenToggle() {
      this.isFullScreen = true;
      this.enterfullscreen();
    },
    enterfullscreen() { //进入全屏
      let docElm = document.getElementById('playVideo')  // 指定容器id
      //W3C
      if (docElm.requestFullscreen) {
        docElm.requestFullscreen()
      }
      //FireFox
      else if (docElm.mozRequestFullScreen) {
        docElm.mozRequestFullScreen()
      }
      //Chrome等
      else if (docElm.webkitRequestFullScreen) {
        docElm.webkitRequestFullScreen()
      }
      //IE11
      else if (elem.msRequestFullscreen) {
        elem.msRequestFullscreen()
      }
    },
    exitFullScreen() {
      console.log('in the exit full screen')
    },
    leaveFullScreen() {
      this.isFullScreen = false;
    },
    pageChange(page) {
      this.destoryReverseVideo();
      this.currentPage = page
      this.getMonitorPoint()
    },
    pageSizeChange(pageSize) {
      this.pageSize = pageSize
      this.getMonitorPoint()
    },
    // 弹窗
    showModal(item) {
      console.log(item)
      console.log(item)
      // this.$emit("orientation", item);
      this.modalIsShow = true;
      this.modalData = item;
    },
    getWarningList() {
      this.$http.post("/api/getMessageAndGaodeList", {}).then(res => {
        if (res.status === 200) {
          this.WarningList = res.data;
        }
      });
    }
  }
}
</script>

<style scoped lang="less">
@import "RoadDynamics.less";

.more {
  color: #13C8FC;
  font-size: .6rem !important;
  margin-right: 2rem;
  cursor: pointer;
  z-index: 99999;
}

:deep(.ivu-page-item) {
  background-color: transparent;
  border: 1px solid #2E6B9E;
}

:deep(.ivu-page-next) {
  background-color: transparent;
  border: 1px solid #2E6B9E;
}

:deep(.ivu-page-prev) {
  background-color: transparent;
  border: 1px solid #2E6B9E;
}

:deep(.ivu-page-item-active) {
  background-color: #2E6B9E;
  border: 1px solid #2E6B9E;
}

//:deep(.flvh265div-4) {
//  .containeritem {
//    height: 45%!important;
//  }
//}
:deep(.flvh265div-4) {
  .containeritem {
    //height: 30%!important;
    height: 27vh !important;
  }
}

:deep(.flvh265div-9) {
  .containeritem {
    //height: 30%!important;
    height: 19vh !important;
  }
}
</style>
